module.exports = __webpack_public_path__ + "assets/snapengage.d35005c9.svg";